<script setup>
// ============================================================================
// BonBoZ: VÒNG NỬA (gauge) — hai miếng trên một nửa cung, kiểu Pancake.
//
// Vì sao nửa cung chứ không tròn đầy: chỉ có HAI miếng và chúng luôn cộng lại
// thành 100%. Nửa cung để trống nửa dưới cho con số tổng và hai mốc phần trăm
// ở hai đầu — đúng chỗ Pancake đặt, và cũng là chỗ mắt tìm tới trước.
//
// KHÔNG CÓ DỮ LIỆU vẫn phải vẽ một cung xám: canvas trống trông như biểu đồ
// hỏng, còn cung xám đọc ra ngay là "kỳ này chưa có gì".
//
// Đăng ký ở thân module, cùng lý do đã ghi ở `BieuDoTron.vue`: onMounted của
// component CHA chạy SAU của con, mà `<Chart>` dựng biểu đồ ngay trong
// onMounted của nó — controller chưa đăng ký thì canvas trắng vĩnh viễn.
// ============================================================================
import { computed } from 'vue';
import { Chart } from 'vue-chartjs';
import {
  Chart as ChartJS,
  ArcElement,
  DoughnutController,
  Tooltip,
} from 'chart.js';

const props = defineProps({
  // [{ nhan, so, nen }] — `nen` là chuỗi rgb() đã tính sẵn: canvas không hiểu
  // biến CSS, xem đầu `helper/mauBieuDo.js`.
  mieng: { type: Array, default: () => [] },
  trong: { type: String, default: '' },
});

ChartJS.register(ArcElement, DoughnutController, Tooltip);

const coSo = computed(() => props.mieng.some(m => m.so > 0));

const duLieu = computed(() => ({
  labels: coSo.value ? props.mieng.map(m => m.nhan) : [''],
  datasets: [
    {
      data: coSo.value ? props.mieng.map(m => m.so) : [1],
      backgroundColor: coSo.value ? props.mieng.map(m => m.nen) : [props.trong],
      // Không kẻ viền giữa các miếng: viền mặc định màu trắng, sang nền tối
      // thành những khe sáng chói.
      borderWidth: 0,
    },
  ],
}));

const tuyChon = computed(() => ({
  responsive: true,
  maintainAspectRatio: false,
  cutout: '76%',
  // Nửa trên: bắt đầu ở 9 giờ (270°) và quét 180°.
  rotation: 270,
  circumference: 180,
  plugins: {
    legend: { display: false },
    tooltip: { enabled: coSo.value },
  },
}));
</script>

<template>
  <Chart type="doughnut" :data="duLieu" :options="tuyChon" />
</template>
